module.exports = __webpack_public_path__ + "media/more_info/chart-442d5825.svg";